import React from 'react';
import { CommonOktaStyling } from './CommonStyling';
import classess from './OktaSignInWidget.scss';

function rememberMe(unCheckedIcon,CheckedIcon) {
  const keepMeSign = document.querySelector('#okta-sign-in .custom-checkbox');
  if(keepMeSign){
    keepMeSign.style.display = 'none';
  }
  const rememberMeParent = document.querySelector('#okta-sign-in .o-form-input-name-rememberMe');
  const popupPage = document.getElementById("resetPassword-cancel-button");
  if(rememberMeParent && popupPage === null){
    if(!document.querySelector('#rememberMe')){
      const rememberMe = document.createElement('div');
      rememberMe.className = 'custom-checkbox';
      rememberMe.id = 'rememberMe';
  
      const rememberMeInput = document.createElement('input');
      rememberMeInput.name = 'remember-me-input';
      rememberMeInput.id = 'rememberCheckbox';
      rememberMeInput.type = 'checkbox';
      rememberMeInput.classList.add(classess.rememberInput);
      rememberMeInput.addEventListener('click',(event) =>{
        const rememberLabel = document.querySelector('.remember-me-label');
        if(rememberLabel){
          if(event.target.checked){
            rememberLabel.style.background = `URL(${CheckedIcon}) no-repeat`;
          } else{
            rememberLabel.style.background = `URL(${unCheckedIcon}) no-repeat`;
          }
        }
      });
  
      const rememberMeLabel = document.createElement('label');
      rememberMeLabel.className = 'remember-me-label';
      rememberMeLabel.classList.add(classess.rememberLabel);
      rememberMeLabel.textContent = 'Remember me';
      rememberMeLabel.style.background = `URL(${unCheckedIcon}) no-repeat`;
      rememberMeLabel.setAttribute('for', 'rememberCheckbox');
  
      rememberMe.appendChild(rememberMeInput);
      rememberMe.appendChild(rememberMeLabel);
      
      rememberMeParent.appendChild(rememberMe);
      if(app.appService.getCookie('rememberMe')){
        const rememberLabel = document.querySelector('.remember-me-label');
        const rememberInput = document.querySelector('#rememberCheckbox');
        if(rememberLabel){
          rememberLabel.style.background = `URL(${CheckedIcon}) no-repeat`;
          rememberInput.checked = true;
        }
      }
    }
  }
}

function addForgotPassLink(){
  const submitButton = document.querySelector('#okta-sign-in.auth-container .button-primary');
  if (!document.querySelector('.forgot-pass-link')) {
    const forgotPassLink = document.createElement('a');
    forgotPassLink.href = '';
    forgotPassLink.className = 'forgot-pass-link';
    forgotPassLink.textContent = 'Forgot Password?';
    forgotPassLink.style.color = CommonOktaStyling.TEXT_COLOR_BLUE;
    forgotPassLink.style.fontFamily = "'open sans', sans-serif";
    forgotPassLink.style.display = 'inline-block';
    forgotPassLink.style.marginBottom = CommonOktaStyling.MARGIN_XS;
    forgotPassLink.style.marginTop = '-12px';
    forgotPassLink.style.float = 'left';
    forgotPassLink.style.textDecoration = 'none';
    forgotPassLink.classList.add(classess.textSizeXS,classess.anchorTagStyle);

    forgotPassLink.addEventListener('click', (event) => {
      event.preventDefault();
      app.appService.setSessionstorage('forgotPasswwordCameFrom',window.location.pathname);
      app.appUtil.navigateTo(app.appUtil.getAppRoutes().LOGIN.RESET_PASSWORD);
    });

    if (submitButton && submitButton.parentNode) {
      submitButton.parentNode.insertBefore(forgotPassLink, submitButton);
    }
  }
}

function addRegisterLink(){
  const submitButton = document.querySelector('#okta-sign-in.auth-container .button-primary');
  if (!document.querySelector('.register-link')) {
    const registerText = document.createElement('span');
    registerText.textContent = 'New to SCE.com? ';
    registerText.classList.add(classess.registerLink);
    const registerLink = document.createElement('a');
    registerLink.href = '';
    registerLink.className = 'register-link';
    registerLink.classList.add(classess.registerLink,classess.anchorTagStyle);
    registerLink.classList.add(classess.register);
    registerLink.textContent = 'Register';
    registerLink.style.color = CommonOktaStyling.TEXT_COLOR_BLUE;
    registerLink.style.textDecoration = 'none';
    
    registerLink.addEventListener('click', (event) => {
      event.preventDefault();
      app.appUtil.navigateTo(app.appUtil.getAppRoutes().REGISTER.USER_REGISTRATION);
    });
    const registerContainer = document.createElement('div');
    registerContainer.appendChild(registerText);
    registerContainer.appendChild(registerLink);
    registerContainer.style.textAlign = CommonOktaStyling.TEXT_ALIGN_CENTER;
    registerContainer.style.marginTop = CommonOktaStyling.MARGIN_XS;
    registerContainer.style.lineHeight = '20px';
    if (submitButton) {
      submitButton.insertAdjacentElement('afterend', registerContainer);
    }
  }
}
function loginButton() {
  const submitButton = document.querySelector('#okta-sign-in.auth-container .button-primary');
  if (submitButton) submitButton.value = 'LOG IN';
  
 
}

function passwordEyeIcon() {
  const style = document.createElement("style");
  style.textContent = `
.eyeicon:focus {
// Style needs to be updated as per SCE.com
	outline: none;
	box-shadow: 0 0 0 2px #4da3ff; 
	border-radius: 4px;
}
`;

  document.head.appendChild(style);

  const eyeIconShow = document.querySelector(".eyeicon.button-show");
  eyeIconShow.setAttribute("tabindex", "0");
  eyeIconShow.setAttribute("role", "button");
  eyeIconShow.setAttribute("aria-label", "Show password");

  const eyeIconHide = document.querySelector(".eyeicon.button-hide");
  eyeIconHide.setAttribute("tabindex", "0");
  eyeIconHide.setAttribute("role", "button");
  eyeIconHide.setAttribute("aria-label", "Hide password");

  eyeIconShow.addEventListener("keydown", (e) => {
    if (e.key === " ") {
      e.preventDefault();
      eyeIconShow.click();
      eyeIconHide.focus();
    }
  });

  eyeIconHide.addEventListener("keydown", (e) => {
    if (e.key === " ") {
      e.preventDefault();
      eyeIconHide.click();
      eyeIconShow.focus();
    }
  });
}

export default function OktaLoginScreenCss(unCheckedIcon,CheckedIcon,defaultEmailValue) {
  // change username placeholder
  const usernameInput = document.querySelector('input[name="identifier"]');
  if (usernameInput) {
    usernameInput.placeholder = 'Enter your Email address';
    usernameInput.style.boxShadow = CommonOktaStyling.BOX_SHADOW;
    usernameInput.classList.add(classess.loginPlaceholder);
    if(!app.appService.getCookie('rememberMe')){
      usernameInput.value = '';
      usernameInput.dispatchEvent(new Event('change',{bubbles:true,cancelable:true}));
    }
    // Password reset default value.
    if(defaultEmailValue){
      usernameInput.value = defaultEmailValue;
      usernameInput.dispatchEvent(new Event('change',{bubbles:true,cancelable:true}));
    }
  }

  // const inputSpan = document.querySelectorAll('#okta-sign-in .o-form .input-fix');
  // if (inputSpan) {
  //   inputSpan.forEach((element) => {
  //     element.classList.add(classess.borderRadius);
  //   });
  // }

  // change password placeholder
  const passwordInput = document.querySelector('input[name="credentials.passcode"]');
  if (passwordInput) {
    passwordInput.placeholder = 'Enter your password';
    passwordInput.style.boxShadow = CommonOktaStyling.BOX_SHADOW;
    passwordInput.classList.add(classess.loginPlaceholder);
    // Password reset default value.
    if(defaultEmailValue){
      passwordInput.value = '';
      passwordInput.dispatchEvent(new Event('change',{bubbles:true,cancelable:true}));
    }
  }

  const inputButton = document.querySelector('button[type="submit"]');
  if(inputButton){
    inputButton.addEventListener('click', function() {
      const rememberLabel = document.querySelector('.remember-me-label');
      const checkbox = document.querySelector('#rememberCheckbox');
      if (rememberLabel) {
        if (checkbox.checked) {
          var now = new Date();
          now = now.setFullYear(now.getFullYear() + 1);
          var duedate = new Date(now);
          app.appService.setCookieWithExpiry('rememberMe', 'true', '/', duedate.toUTCString());
        } else {
          app.appService.removeCookie('rememberMe', '', '/');
        }
      }
    });
  }
  
  const keepMeCheckbox = document.querySelector('#okta-sign-in .o-form .o-form-fieldset:last-child');
  if (keepMeCheckbox) keepMeCheckbox.style.marginBottom = CommonOktaStyling.MARGIN_NONE;

  rememberMe(unCheckedIcon,CheckedIcon);

  passwordEyeIcon();

  loginButton();
  let showForgotPassLink = true;
  let showRegisterLink = !document.getElementById("resetPassword-cancel-button");
  try {
    if (drupalSettings.custom.loginRedirectionData.resetPassword) {
      showForgotPassLink = (drupalSettings.custom.loginRedirectionData.resetPassword === 'true');
    }

    if (drupalSettings.custom.loginRedirectionData.registration) {
      showRegisterLink = (drupalSettings.custom.loginRedirectionData.registration === 'true') && showRegisterLink;
    }
  } catch (err) {
    // drupal object not available
  }


  if (showForgotPassLink) {
    addForgotPassLink();
  }


  if (showRegisterLink) {
    addRegisterLink();
  }

  const authFooter = document.querySelector('#okta-sign-in .auth-footer');
  if (authFooter) {
    authFooter.style.display = 'none';
  }

  const anchorTag = document.querySelectorAll('#okta-sign-in a');
  if(anchorTag){
    anchorTag.forEach(element => element.style.textDecoration = 'none');
  }
}
